import { Box, Spacer, Stack, Text } from '@chakra-ui/react'
import { faChevronRight, faProjectDiagram } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'swiper/swiper-bundle.css'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

import ProfileItemContainer from './ProfileItemContainer'

export default function ProfileTutorNetwork({ user }: { user: Query }): JSX.Element | null {
  const isUserTutor = user(UserQ.hasTutorRole()) ?? false
  const firstName = user(UserQ.first_name) ?? ''
  const userId = user(UserQ.id) ?? 0
  const username = user(UserQ.username)

  if (!isUserTutor) {
    return null
  }

  return (
    <Box>
      <ShwLink width="100%" href={`${getUserUrl({ userId, username })}/network`}>
        <ProfileItemContainer>
          <Stack direction="row" spacing="24px" align="center">
            <Text color="gray.fg" fontSize="32px">
              <FontAwesomeIcon icon={faProjectDiagram} />
            </Text>
            <Box>
              <Text variant="eyebrow" mb={2}>
                Tutor Network
              </Text>
              <Text fontWeight={600}>See {firstName}&apos;s tutor network</Text>
            </Box>
            <Spacer />
            <Text color="gray.fg">
              <FontAwesomeIcon icon={faChevronRight} />
            </Text>
          </Stack>
        </ProfileItemContainer>
      </ShwLink>
    </Box>
  )
}
